import React, { Component } from "react";
import FormField from "../FormField";
import { Row, Col, Button } from "antd";
import { FieldArray } from "formik";
import {
  Wrapper,
  TextArea,
  FieldLabel,
  NumberText,
  DeleteIcon
} from './styles'

export default class BriefDont extends Component {
  render() {
    const {
      values: { brief_dont },
    } = this.props;

    return (
      <FieldArray
        name={`brief_dont`}
      >
        {({ insert, remove, push }) => (
          <Wrapper>
            <FieldLabel>
              What are the 3-5 influencers should not say about your brand?
            </FieldLabel>
            {typeof brief_dont !== "undefined" &&
              brief_dont.length > 0 &&
              brief_dont.map((data, index) => {
                return (
                  <Row gutter={8} key={index}>
                    <Col span={1}>
                      <NumberText>{index + 1}.</NumberText>
                    </Col>
                    <Col span={22}>
                      <FormField
                        name={`brief_dont[${index}]`}
                        label=""
                        style={{ marginBottom: 0 }}
                      >
                        <TextArea
                          data-cy={`brief-dont-input[${index}]`}
                          rows={1}
                          size="large"
                          placeholder="e.g. Should not compare your brand to another"
                        />
                      </FormField>
                    </Col>

                    <Col span={1}>
                      <DeleteIcon
                        type="delete"
                        data-cy={`brief-dont-input-delete[${index}]`}
                        onClick={() => remove(index)}
                      />
                    </Col>
                  </Row>
                );
              })}
            <Row gutter={8}>
              <Col span={22}>
                <Button type="link" onClick={() => push("")}>
                  + Add
                </Button>
              </Col>

              <Col span={2}></Col>
            </Row>
          </Wrapper>
        )}
      </FieldArray>
    );
  }
}
